import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles({
    text: {
        '&&': {
            fontFamily: `'Rubik', sans-serif`,
        }
    },
    message: {
        '&&': {
            marginBottom: 10,
            '@media (max-width: 960px)': {
                padding: '0 20px'
            }
        }
    },
    center: {
        '&&': {
            alignText: 'center'
        }
    },
    input: {
        '&&': {
            width: '100%',
            fontFamily: `'Rubik', sans-serif`,
            color: 'white',
            padding: '0 15px'
        }
    },
    button: {
        '&&': {
            width: 30,
            minWidth: 0,
            height: 30,
            borderRadius: 12.5,
            justifyContent: 'center',
            alignItems: 'center',
            backgroundColor: '#696969',
            '&:hover': {
                backgroundColor: '#696969E6'
            }
        }
    }
});